import environmentConfig from "configuration/environmentConfig";
import { UserManager, type UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

const host = `${window.location.protocol}//${window.location.host}`;

const config: UserManagerSettings = {
  client_id: environmentConfig.stsClientId,
  redirect_uri: `${host}/auth-callback`,
  post_logout_redirect_uri: `${host}/signout-callback`,
  response_type: "code",
  scope: "openid profile account gateway.fullAccess",
  authority: environmentConfig.stsUrl,
  automaticSilentRenew: true,
  silent_redirect_uri: `${host}/silent-renew.html`,
  filterProtocolClaims: true,
  loadUserInfo: true,
  monitorSession: true,
  checkSessionIntervalInSeconds: 15,
  userStore: new WebStorageStateStore({ store: window.localStorage }),
};

export const userManager = new UserManager(config);

export const accessTokenFactory = async () => {
  const user = await userManager.getUser();
  return user?.access_token;
};
